import { Navigate, Route, Routes } from 'react-router-dom'
import { PageHeader } from '../../components/ui'
import { DocLocateTemplateFields } from './DocLocateTemplateFields'
import { DocLocateTemplateList } from './DocLocateTemplateList'

export default function DocLocateSettings() {
  return (
    <>
      <PageHeader
        title="文档定位"
        description="维护定位模板与字段定义，供前台「文档定位」应用选用；字段抽取智能体见「智能体 → 文档定位」。"
      />
      <Routes>
        <Route index element={<DocLocateTemplateList />} />
        <Route path=":templateId" element={<DocLocateTemplateFields />} />
        <Route path="*" element={<Navigate to="/manage/doc-locate" replace />} />
      </Routes>
    </>
  )
}
